import { okResponse } from '@crow/service-kit/web/api';
import {
  type ComputerUseAction,
  type ComputerUseStatus,
  computerUseStatusSchema,
} from '@crowdex/agent-contracts/api';
import { apiRefusals } from '@crowdex/host-kit/renderer/http';
import {
  connectLocalWorkspaceServer,
  localServerUrl,
  localWorkspaceServer,
} from '@/lib/local-runtime';

/*
 * Computer use on the machine `crowdex serve` runs on: its state and settings live with the
 * local workspace server (`/v1/computer`), which runs Cua Driver for the agents.
 */

async function request(init?: RequestInit): Promise<ComputerUseStatus> {
  if (localWorkspaceServer() === null) await connectLocalWorkspaceServer();
  const server = localWorkspaceServer();
  if (server === null) throw new Error('The local server is not available.');
  // This machine's workspace server, not the app's API: its refusals read as the app's.
  const response = await okResponse(
    await fetch(localServerUrl(server, '/v1/computer'), {
      ...init,
      headers: { authorization: `Bearer ${server.token}`, 'content-type': 'application/json' },
    }),
    { ...apiRefusals, fallbackMessage: (status) => `Computer use is not available (${status}).` },
  );
  return computerUseStatusSchema.parse(await response.json());
}

export function loadComputerUse(): Promise<ComputerUseStatus> {
  return request({ cache: 'no-store' });
}

export function updateComputerUse(action: ComputerUseAction): Promise<ComputerUseStatus> {
  return request({ method: 'POST', body: JSON.stringify(action) });
}
